module.exports = __webpack_public_path__ + "static/media/flask_logo.409c7035.jpg";